import React from 'react';
import LazyLoad from '../../common/components/LazyLoad';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import { Icon } from '../../common/components/Utilities';

export default function ({
  user,
  reviewer,
  type,
  start,
  end,
}) {
  return (
    <LazyLoad
      resourceAction={LegacyUserResource.reviewRating}
      params={[user, reviewer, type, start, end]}
      defaultData={0}
      render={(loading, { average, count, desc }) => {
        if (loading) {
          return <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />;
        }

        if (count === 0) {
          return <div className="text-muted text-italic">Not enough data.</div>;
        }

        let style = '';

        switch (average) {
          case 1:
            style = 'text-danger';
            break;

          case 2:
            style = 'text-warning';
            break;

          case 4:
            style = 'text-success';
            break;

          case 5:
            style = 'text-success';
            break;

          case 3:
          default:
            style = 'text-success';
            break;
        }

        return (
          <>
            <div className={style}>
              {desc}
            </div>

            <div className="small text-muted">
              {`Based on ${count} ${count === 1 ? 'review' : 'reviews'}.`}
            </div>
          </>
        );
      }}
    />
  );
}
